import React from 'react';

interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  containerClass?: string;
}

export const Section: React.FC<SectionProps> = ({ children, className = '', id, containerClass='' }) => {
  return (
    <section id={id} className={`py-14 sm:py-20 ${className}`}>
      <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${containerClass}`}>
        {children}
      </div>
    </section>
  );
};
